import { render, staticRenderFns } from "./CohortRegistrationResultsPage.vue?vue&type=template&id=ce00a8ee"
import script from "./CohortRegistrationResultsPage.vue?vue&type=script&lang=js"
export * from "./CohortRegistrationResultsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports